const comms = {
  title: "Коммуникация",
  allChannels: "Все",
  notes: "Заметки",
  noMessages: "Нет сообщений",
  loadMore: "Загрузить ещё",
  pin: "Закрепить",
  unpin: "Открепить",
  composePlaceholder: "Написать сообщение...",
  templates: "Шаблоны",
  send: "Отправить",
  openPanel: "Открыть коммуникацию",
  inbound: "Входящий",
  outbound: "Исходящий",
  internal: "Внутренний",
  pageTitle: "Коммуникация",
  pageDescription: "Все сообщения, звонки и переписки в одном месте",
  search: "Поиск сообщений...",
  filterChannel: "Канал",
  filterDirection: "Направление",
  filterRead: "Прочитано",
  filterDate: "Дата",
  all: "Все",
  read: "Прочитано",
  unread: "Непрочитано",
  sender: "Отправитель",
  phone: "Телефон",
  content: "Содержание",
  date: "Дата",
  channel: "Канал",
  whatsapp: "WhatsApp",
  email: "Эл. почта",
  reminder: "Напоминание",
  addCall: "Добавить звонок",
  addCallTitle: "Добавить новый звонок",
  phoneName: "Телефон / Имя",
  direction: "Направление",
  summary: "Итог",
  dateTime: "Дата и время",
  save: "Сохранить",
  cancel: "Отмена",
  unreadCount: "Непрочитанные",
  sortBy: "Сортировка",
  tabCalls: "Звонки",
  tabMessages: "Сообщения",
  tabContacts: "Контакты",
  tabDocs: "Документы",
  tabEmails: "Почта",
  tabNotifications: "Уведомления",
  showLabel: "Показать:",
  comingSoonTab: "Скоро — ещё не подключено",
  sectionContacts: "Контакты",
  sectionTimeline: "Хронология",
  sectionEmails: "Почта",
  sectionNotifications: "Уведомления",
  noEmails: "Нет отправленных писем",
  noNotifications: "Нет уведомлений",
  thinking: "Думает...",
  timeNow: "сейчас",
  timeYesterday: "вчера",
  missedCall: "Пропущенный",
  noteLabel: "Заметка",
  messagesCount: "сообщ.",
  statusSent: "Отправлено",
  statusFailed: "Ошибка",
} as const;
export default comms;
